import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex/store'
import {get} from 'lodash'
import User from '../assets/js/User.class'
const LoginPage = () => import('pages/login.vue')
const ResetPasswordPage = () => import('pages/reset-password')
const Hello = () => import('components/Hello.vue')
const Layout = () => import('pages/layout')

const UsersPage = () => import('pages/users/index.vue')
const UserCreatePage = () => import('pages/users/create.vue')
const UserIdPage = () => import('pages/users/id.vue')
const UserUpdatePage = () => import('pages/users/update.vue')
const VacanciesPage = () => import('pages/vacancy/index.vue')
const VacanciesCreatePage = () => import('pages/vacancy/create.vue')
const VacanciesIdPage = () => import('pages/vacancy/id.vue')
const VacanciesUpdatePage = () => import('pages/vacancy/update.vue')
const NewsPage = () => import('pages/news/index.vue')
const NewsCreatePage = () => import('pages/news/create.vue')
const NewsIdPage = () => import('pages/news/id.vue')
const NewsUpdatePage = () => import('pages/news/update.vue')
const EventsPage = () => import('pages/events/index.vue')
const EventsIdPage = () => import('pages/events/id.vue')
const EventsUpdatePage = () => import('pages/events/update.vue')
const EventsCreatePage = () => import('pages/events/create.vue')
const TestsPage = () => import('pages/tests/index.vue')
const TestsCreatePage = () => import('pages/tests/create.vue')
const TestsIdPage = () => import('pages/tests/id.vue')
const TestsUpdatePage = () => import('pages/tests/update.vue')
const CompanyPage = () => import('pages/company/index.vue')
const CompanyCreate = () => import('pages/company/create.vue')
const CompanyIdPage = () => import('pages/company/id.vue')
const CompanyUpdatePage = () => import('pages/company/update.vue')
const CityPage = () => import('pages/city.vue')
const RegionPage = () => import('pages/region.vue')
const EventTypePage = () => import('pages/event-type')
const EventPlacePage = () => import('pages/event-place')
const EventPlaceCreatePage = () => import('pages/event-place/create')
const EventPlaceUpdatePage = () => import('pages/event-place/update')
const EventDirectionPage = () => import('pages/event-direction')
const EventRejectReasonPage = () => import('pages/event-reject-reason')
const EventStatusPage = () => import('pages/event-status')
const EventTagPage = () => import('pages/event-tag')
const EventThemePage = () => import('pages/event-theme')
const EventAccessTypePage = () => import('pages/event-access-type')
const EventPurposePage = () => import('pages/event-purpose')
const CompetencesPage = () => import('pages/competences/index')
const CompetencesIdPage = () => import('pages/competences/id')
const EmploymentsPage = () => import('pages/employments/index')
const PagesPage = () => import('pages/pages/index')
const PagesSlugPage = () => import('pages/pages/slug')
const PagesUpdatePage = () => import('pages/pages/update')
const ErrorPage = () => import('pages/error')
const ModulesPage = () => import('pages/modules/index')
const ModulesCreatePage = () => import('pages/modules/create')
const ModulesIdPage = () => import('pages/modules/id')
const ModulesUpdatePage = () => import('pages/modules/update')
const MentorsPage = () => import('pages/mentors/index')
const MentorsCreatePage = () => import('pages/mentors/create')
const MentorsIdPage = () => import('pages/mentors/id')
const MentorsUpdatePage = () => import('pages/mentors/update')
const FileManager = () => import('pages/filemanager')
const TendersPage = () => import('pages/tenders/index')
const TendersCreatePage = () => import('pages/tenders/create')
const TendersUpdatePage = () => import('pages/tenders/update')
const NewsletterPage = () => import('pages/newsletter/index')
const EducationsPage = () => import('pages/educations/index')
const EducationsCreatePage = () => import('pages/educations/create')
const EducationsUpdatePage = () => import('pages/educations/update')
const NotifyPage = () => import('pages/notify/index')
const NotifyCreatePage = () => import('pages/notify/create')
const NotifyUpdatePage = () => import('pages/notify/update')
const NotificationPage = () => import('pages/notification/index')
const LogsPage = () => import('pages/logs/index')
const LogPage = () => import('pages/logs/id')
const QueuePage = () => import('pages/horizon')
const NewsCategoriesPage = () => import('pages/news-category/index')
const NewsCategoryPage = () => import('pages/news-category/id')
const NewsCategoryUpdatePage = () => import('pages/news-category/update')
const NewsCategoryCreatePage = () => import('pages/news-category/create')
const NewsTagsPage = () => import('pages/news-tag/index')
const NewsTagPage = () => import('pages/news-tag/id')
const NewsTagUpdatePage = () => import('pages/news-tag/update')
const NewsTagCreatePage = () => import('pages/news-tag/create')

const TournamentList = () => import('pages/tournament/index')
const TournamentCreate = () => import('pages/tournament/create')
const TournamentUpdate = () => import('pages/tournament/update')
const TournamentParticipants = () => import('pages/tournament/_id/participants')
const TournamentFormToJuri = () => import('pages/tournament/_id/_juri')

const TourList = () => import('pages/tour/index')
const TourUpdate = () => import('pages/tour/update')
const TourCreate = () => import('pages/tour/create')

const EducationTrackCreate = () => import('pages/education-track/create')
const EducationTrackIndex = () => import('pages/education-track/index')
const EducationTrackId = () => import('pages/education-track/id')
const EducationTrackUpdate = () => import('pages/education-track/update')

const RoleIndex = () => import('pages/roles/index')
const RoleShow = () => import('pages/roles/show')

Vue.use(Router)

async function loginFromSocial (codeParam) {
	if (codeParam) {
		const {data, status} = await store.dispatch('user/loginSocial', codeParam)
		const user = new User(data.data)
		if (status < 300) {
			if (user.permissionAccess) {
				// window.close()
				localStorage.setItem('access_token', data.access_token)
				localStorage.setItem('token_type', data.token_type)
				// this.$router.push(`/user/${user.data.id}`)
			} else {
				global.toastr['error'](`Доступ отклонён`)
				await store.dispatch('user/logout')
				this.$router.push('/login')
			}
		} else {
			console.log('Ошибка авторизации')
			console.log(data.message || 'Что-то пошло не так')
		}
	}
}

const ifLogged = async (to, from, next) => {
	const token = localStorage.getItem('access_token')
	const tokenType = localStorage.getItem('token_type')

	if (store.getters['user/isLoggedIn']) {
		next()
	} else {
		if (get(to, 'query.code')) {
			await loginFromSocial(to.query.code)
		} else if (token && tokenType) {
			await store.dispatch('user/checkUser', {
				token,
				tokenType
			})
		} else {
			next({
				name: 'LoginPage',
				params: {
					returnURL: window.location.pathname + window.location.search + window.location.hash
				}
			})
		}

		if (store.getters['user/isLoggedIn']) {
			next()
		} else {
			next({
				name: 'LoginPage',
				params: {
					returnURL: window.location.pathname + window.location.search + window.location.hash
				}
			})
		}
	}
}

let router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/reset',
			name: 'ResetPasswordPage',
			meta: {
				showAll: true
			},
			component: ResetPasswordPage
		},
		{
			path: '/login',
			name: 'LoginPage',
			meta: {
				showAll: true
			},
			component: LoginPage
		},
		{
			path: '/',
			name: 'Admin',
			meta: {
				showAll: true
			},
			component: Layout,
			beforeEnter: ifLogged,
			children: [
				{
					path: '/',
					name: 'Hello',
					component: Hello,
					meta: {
						roles: ['admin']
					}
				},
				{
					path: 'role',
					name: 'role',
					component: RoleIndex
				},
				{
					path: 'roles/:role',
					name: 'role-show',
					component: RoleShow
				},
				{
					path: 'users',
					name: 'users',
					component: UsersPage
				},
				{
					path: 'users/create',
					name: 'users-create',
					component: UserCreatePage
				},
				{
					path: 'users/:id',
					name: 'users-show',
					component: UserIdPage
				},
				{
					path: 'users/:id/update',
					name: 'users-update',
					component: UserUpdatePage
				},
				{
					path: 'vacancies',
					name: 'vacancies',
					component: VacanciesPage
				},
				{
					path: 'vacancies/create',
					name: 'vacancies-create',
					component: VacanciesCreatePage
				},
				{
					path: 'vacancies/:id',
					name: 'vacancies-show',
					component: VacanciesIdPage
				},
				{
					path: 'vacancies/:id/update',
					name: 'vacancies-update',
					component: VacanciesUpdatePage
				},
				{
					path: 'news',
					name: 'news',
					component: NewsPage
				},
				{
					path: 'news/create',
					name: 'news-create',
					component: NewsCreatePage
				},
				{
					path: 'news/:id',
					name: 'news-show',
					component: NewsIdPage
				},
				{
					path: 'news/:id/update',
					name: 'news-update',
					component: NewsUpdatePage
				},
				{
					path: 'news-category',
					name: 'news-category',
					component: NewsCategoriesPage
				},
				{
					path: 'news-category/create',
					name: 'news-category-create',
					component: NewsCategoryCreatePage
				},
				{
					path: 'news-category/:id',
					name: 'news-category-show',
					component: NewsCategoryPage
				},
				{
					path: 'news-category/:id/update',
					name: 'news-category-update',
					component: NewsCategoryUpdatePage
				},
				{
					path: 'news-tag',
					name: 'news-tag',
					component: NewsTagsPage
				},
				{
					path: 'news-tag/create',
					name: 'news-tag-create',
					component: NewsTagCreatePage
				},
				{
					path: 'news-tag/:id',
					name: 'news-tag-show',
					component: NewsTagPage
				},
				{
					path: 'news-tag/:id/update',
					name: 'news-tag-update',
					component: NewsTagUpdatePage
				},
				{
					path: 'events',
					name: 'events',
					component: EventsPage
				},
				{
					path: 'events/create',
					name: 'events-create',
					component: EventsCreatePage
				},
				{
					path: 'events/:id',
					name: 'events-show',
					component: EventsIdPage
				},
				{
					path: 'events/:id/update',
					name: 'events-update',
					component: EventsUpdatePage
				},
				{
					path: 'tests',
					name: 'tests',
					component: TestsPage
				},
				{
					path: 'tests/create',
					name: 'tests-create',
					component: TestsCreatePage
				},
				{
					path: 'tests/:id',
					name: 'tests-show',
					component: TestsIdPage
				},
				{
					path: 'tests/:id/update',
					name: 'tests-update',
					component: TestsUpdatePage
				},
				{
					path: 'company',
					name: 'company',
					component: CompanyPage
				},
				{
					path: 'company/create',
					name: 'company-create',
					component: CompanyCreate
				},
				{
					path: 'company/:id',
					name: 'company-show',
					component: CompanyIdPage
				},
				{
					path: 'company/:id/update',
					name: 'company-update',
					component: CompanyUpdatePage
				},
				{
					path: 'city',
					name: 'city',
					component: CityPage
				},
				{
					path: 'region',
					name: 'region',
					component: RegionPage
				},
				{
					path: 'event-type',
					name: 'event-type',
					component: EventTypePage
				},
				{
					path: 'event-place',
					name: 'event-place',
					component: EventPlacePage
				},
				{
					path: 'event-place/create',
					name: 'event-place-create',
					component: EventPlaceCreatePage
				},
				{
					path: 'event-place/:id/update',
					name: 'event-place-update',
					component: EventPlaceUpdatePage
				},
				{
					path: 'event-direction',
					name: 'event-direction',
					component: EventDirectionPage
				},
				{
					path: 'event-reject-reason',
					name: 'event-reject-reason',
					component: EventRejectReasonPage
				},
				{
					path: 'event-status',
					name: 'event-status',
					component: EventStatusPage
				},
				{
					path: 'event-tag',
					name: 'event-tag',
					component: EventTagPage
				},
				{
					path: 'event-theme',
					name: 'event-theme',
					component: EventThemePage
				},
				{
					path: 'event-access-type',
					name: 'event-access-type',
					component: EventAccessTypePage
				},
				{
					path: 'event-purpose',
					name: 'event-purpose',
					component: EventPurposePage
				},
				{
					path: 'competences',
					name: 'competences',
					component: CompetencesPage
				},
				{
					path: 'competences/:id',
					name: 'competences-show',
					component: CompetencesIdPage
				},
				{
					path: 'modules',
					name: 'modules',
					component: ModulesPage
				},
				{
					path: 'modules/create',
					name: 'modules-create',
					component: ModulesCreatePage
				},
				{
					path: 'modules/:id',
					name: 'modules-show',
					component: ModulesIdPage
				},
				{
					path: 'modules/:id/update',
					name: 'modules-update',
					component: ModulesUpdatePage
				},
				{
					path: 'mentors',
					name: 'mentors',
					component: MentorsPage
				},
				{
					path: 'mentors/create',
					name: 'mentors-create',
					component: MentorsCreatePage
				},
				{
					path: 'mentors/:id',
					name: 'mentors-show',
					component: MentorsIdPage
				},
				{
					path: 'mentors/:id/update',
					name: 'mentors-update',
					component: MentorsUpdatePage
				},
				{
					path: 'employments',
					name: 'employments',
					component: EmploymentsPage
				},
				{
					path: 'tenders',
					name: 'tenders',
					component: TendersPage
				},
				{
					path: 'tenders/:id/update',
					name: 'tenders-update',
					component: TendersUpdatePage
				},
				{
					path: 'tenders/create',
					name: 'tenders-create',
					component: TendersCreatePage
				},
				{
					path: 'pages',
					name: 'pages',
					component: PagesPage
				},
				{
					path: 'pages/:slug',
					name: 'pages-show',
					component: PagesSlugPage
				},
				{
					path: 'pages/:slug/update',
					name: 'pages-update',
					component: PagesUpdatePage
				},
				{
					path: 'filemanager',
					name: 'filemanager',
					component: FileManager
				},
				{
					path: 'newsletter',
					name: 'newsletter',
					component: NewsletterPage
				},
				{
					path: 'notifications',
					name: 'notifications',
					component: NotificationPage
				},
				{
					path: 'educations',
					name: 'educations',
					component: EducationsPage
				},
				{
					path: 'educations/create',
					name: 'educations-create',
					component: EducationsCreatePage
				},
				{
					path: 'educations/:id/update',
					name: 'educations-update',
					component: EducationsUpdatePage
				},
				{
					path: 'notify',
					name: 'notify',
					component: NotifyPage
				},
				{
					path: 'notify/create',
					name: 'notify-create',
					component: NotifyCreatePage
				},
				{
					path: 'notify/:id/update',
					name: 'notify-update',
					component: NotifyUpdatePage
				},
				{
					path: 'logs',
					name: 'logs',
					component: LogsPage
				},
				{
					path: 'logs/:id',
					name: 'log',
					component: LogPage
				},
				{
					path: 'horizon',
					name: 'horizon',
					component: QueuePage
				},

				{
					name: 'tournament-create',
					path: 'tournament/create',
					component: TournamentCreate
				},
				{
					name: 'tournament-participants',
					path: 'tournament/:id/participants',
					component: TournamentParticipants
				},
				{
					name: 'tournament-participants-form-juri',
					path: 'tournament/:id/juri/:juri',
					component: TournamentFormToJuri
				},
				{
					name: 'tournament-participants-form-juri-update',
					path: 'tournament/:id/update',
					component: TournamentUpdate
				},
				{
					name: 'tournament-list',
					path: 'tournament',
					component: TournamentList
				},
				{
					name: 'tour-create',
					path: 'tour/create',
					component: TourCreate
				},
				{
					name: 'tour-update',
					path: 'tour/:id/update',
					component: TourUpdate
				},
				{
					name: 'tour-list',
					path: 'tour',
					component: TourList
				},

				{
					name: 'education-track-create',
					path: 'education-track/create',
					component: EducationTrackCreate
				},
				{
					name: 'education-track',
					path: 'education-track',
					component: EducationTrackIndex
				},
				{
					name: 'education-track-id',
					path: 'education-track/:id',
					component: EducationTrackId
				},
				{
					name: 'education-track-update',
					path: 'education-track/:id/update',
					component: EducationTrackUpdate
				},

				{
					path: '*',
					name: 'error-page',
					component: ErrorPage,
					meta: {
						showAll: true
					}
				}
			]
		}
	],
	linkActiveClass: 'active'
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js